import type { FormInstance } from 'antd';
import React                 from 'react';
import { getIntl }           from 'utils/getIntl';
import { AppFormComponent }  from 'components/App/AppForm';
import { Col }               from 'antd';
import { Form }              from 'antd';
import RichTextEditor        from 'components/App/RichTextEditor';
import FormItemDragger       from 'components/App/FormItemDragger';
import Row                   from 'components/App/Row';
import MessageMediaModel     from 'models/MessageMediaModel';
import StandMessageModel     from 'models/StandMessageModel';
import handleFormError       from 'utils/handleFormError';
import MessageModel          from 'models/MessageModel';
import StandModel            from 'models/StandModel';

const intl = getIntl();

interface StandMessageFormProps {
  message: MessageModel;
  model: StandMessageModel;
  onSuccess?: (standMessage: StandMessageModel) => void;
  stand: StandModel;
}

class StandMessageForm extends AppFormComponent<StandMessageFormProps> {
  public formRef: React.RefObject<FormInstance> = React.createRef<FormInstance>();

  public componentDidMount() {
    const { message } = this.props;

    this.formRef.current?.setFieldsValue({
      attachments: [],
      content: message.get('content'),
    });
  }

  public render() {
    return (
      <Form ref={this.formRef}>
        <Row>
          <Col span={24}>
            <Form.Item
              label={intl.formatMessage({ id: "Message" })}
              labelCol={{ span: 24 }}
              name="content"
              rules={[
                {
                  message: intl.formatMessage({ id: "Contenu manquant" }),
                  required: true,
                },
              ]}
            >
              <RichTextEditor style={{ height: 150, marginBottom: 32 }} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <FormItemDragger name="attachments" />
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const {
      message,
      model,
      onSuccess,
      setSaveButtonProps,
      stand,
    } = this.props;

    const values = await this.formRef.current?.validateFields();

    setSaveButtonProps({ loading: true });

    try {
      const attachments = [];

      for (let i = 0; i < values.attachments.length; i += 1) {
        const messageMedia = await this.uploadMessageMedia(values.attachments[i].originFileObj);
        attachments.push(messageMedia.data['@id']);
      }

      await message.patch({
        attachments,
        content: values.content,
      });

      await model.patch({
        message: message.iri,
        newStandStatus: model.newStandStatus,
        stand: stand.iri,
      });

      if (onSuccess) {
        onSuccess(model);
      }
    } catch (error) {
      handleFormError(error, this.formRef.current);
    } finally {
      setSaveButtonProps({ loading: false });
    }
  };

  private uploadMessageMedia = async (file: any) => {
    const messageMediaModel = new MessageMediaModel();

    messageMediaModel.set({
      enabled: true,
      file,
    });

    await messageMediaModel.save();

    return messageMediaModel;
  };
}

export default StandMessageForm;
